import { Props as ModalProps } from 'react-modal';
import { IDemandViewModel, IDemandProposalViewModal, ISolicitationViewModel } from 'viewModels';
import { Container } from './styles';
import { CardSolicitationDetails } from '../../Cards/CardSolicitationDetails';
import { CardDemandProposalDetails } from '../../Cards/CardDemandProposalDetails';
import { CardDemandDetails } from '../../Cards/CardDemandDetails';

interface Props extends ModalProps {
  onRequestClose: () => void;
  solicitation?: ISolicitationViewModel;
  demandProposal?: IDemandProposalViewModal;
  zIndex?: number;
  demand?: IDemandViewModel;
  isTutorial?: boolean;
  removeEvent?: () => void;
}

export function ModalDetailsService({
  isOpen,
  solicitation,
  demandProposal,
  onRequestClose,
  zIndex,
  demand,
  removeEvent,
  isTutorial,
}: Props) {
  const setZIndex =
    zIndex !== undefined
      ? {
          overlay: {
            zIndex: zIndex || 1,
          },
        }
      : {};

  return (
    <Container
      id="solicitation-modal"
      style={setZIndex}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-event-details">
      {solicitation && (
        <CardSolicitationDetails
          solicitationParam={solicitation}
          zIndex={zIndex}
          isTutorial={isTutorial}
        />
      )}
      {demandProposal && (
        <CardDemandProposalDetails
          demandProposal={demandProposal}
          onRequestClose={onRequestClose}
          removeEvent={removeEvent}
        />
      )}
      {demand && <CardDemandDetails demandParam={demand} zIndex={zIndex} />}
    </Container>
  );
}
